<template>
  <v-container class="fill-height">
    <v-row class="align-center fill-height justify-center">
      <v-col>
        <template v-if="loading">
          <div class="text-center">
            <v-progress-circular
              size="64"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <div class="title mt-4">กำลังดำเนินการ</div>
          </div>
        </template>
        <template v-else>
          <template v-if="hasErr">
            <template v-if="errCode == 'empty_session_qs'">
              <v-alert type="error">
                <div class="title">Error</div>
                <div>
                  Can not found session detail, please close this window and try
                  again
                </div>
              </v-alert>
            </template>
            <template v-else-if="errCode == 'bad_request'">
              <v-alert type="error">
                <div class="title">Bad Request</div>
                <div>
                  Some data of session detail is missing, please close this
                  window and try again
                </div>
              </v-alert>
            </template>
            <template v-else>
              <div class="text-center mb-4">
                <v-icon color="error" size="64"
                  >far fa-exclamation-triangle</v-icon
                >
              </div>
              <div>Something went wrong can not open evaluate session</div>
            </template>
          </template>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import stringHelper from "../helpers/string";
import sessionService from "../services/evaluateSession";
export default {
  name: "Home",
  data: () => ({
    loading: true,
    hasErr: false,
    errCode: "",
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let encryptSession = this.$route.query.session || null;
      if (encryptSession != null) {
        let decode_query_uri = decodeURIComponent(encryptSession);
        let decrypted = this.$crypto.AES.decrypt(
          decode_query_uri,
          this.$store.state.secretKey
        );
        let sessionData = JSON.parse(decrypted.toString(this.$crypto.enc.Utf8));

        let { token, course, numStamp } = sessionData;

        if (
          !stringHelper.isNullOrEmpty(token) &&
          !stringHelper.isNullOrEmpty(course) &&
          !stringHelper.isNullOrEmpty(numStamp)
        ) {
          // set sessionStorage
          sessionStorage.setItem("token", token);
          sessionStorage.setItem("course", course);
          sessionStorage.setItem("numStamp", numStamp);

          this.initEvaluateSession(sessionData);
        } else {
          // bad request
          // this.errCode = "bad_request";
          // this.loading = false;
          // this.hasErr = true;
          this.$router.replace({
            name: "error",
            params: {
              code: "0x003",
            },
          });
        }

        return;
      } else {
        // empty ticket
        // this.errCode = "empty_session_qs";
        // this.loading = false;
        // this.hasErr = true;
        this.$router.replace({
          name: "error",
          params: {
            code: "0x002",
          },
        });
      }
    },

    initEvaluateSession(data) {
      sessionService
        .initSession(data)
        .then((resp) => {
          sessionStorage.setItem("evalId", resp.data);
          this.$router.replace({
            name: "evaluate",
          });
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            if (err.response.data.code == "redirect") {
              this.$router.replace(err.response.data.message);
            }
          }
        });
    },
  },
};
</script>
